import React, { useState, ReactNode } from "react";
import ElementsContextType from "../../types/ElementsContextType";
import { Inspection } from "../../types/Inspection";
import InspectionElement from "../../types/InspectionElement";
import MainFrameContextType from "../../types/MainFrameContextType";
import { MainFrameContext } from "./MainFrameContext";
import ElementAsset from "../../types/ElementAsset";
import ReactGA from "react-ga4";

export const ElementsContext = React.createContext<ElementsContextType | null>(
    null
);

interface IProps {
    children: ReactNode;
}

export default function ElementsContextProvider({ children }: IProps) {
    const { setShowSideBar, setShowTopBar, setAnchor, setAllowDelete } =
        React.useContext(MainFrameContext) as MainFrameContextType;

    const [elements, setElements] = useState<InspectionElement[]>([]);
    // focused elements used to display in full mode or gallery mode
    const [focusedInspectionElement, setFocusedInspectionElement] =
        useState<InspectionElement>();
    const [focusedImage, setFocusedImage] = useState<ElementAsset>();
    const [showGallery, setShowGallery] = useState(false);
    const [showImageViewer, setShowImageViewer] = useState(false);
    const [inspection, setInspection] = useState<Inspection | undefined>();

    function openGallery(data: InspectionElement) {
        setShowGallery(true);
        setFocusedInspectionElement(data);
        setAnchor("#gallery");
        setAllowDelete(true);

        ReactGA.event({
            category: "Opened Gallery",
            action: "x",
            label: "xx",
            value: 0
        });
    }

    function openImageViewer(image: ElementAsset, element: InspectionElement) {
        setShowImageViewer(true);
        setFocusedInspectionElement(element);
        setFocusedImage(image);
        setShowTopBar(false);
        setShowSideBar(false);
        setAnchor("#viewer");

        ReactGA.event({
            category: "Image viewer",
            action: "opened",
            label: element.Name,
            value: 0
        });
    }

    function closeImageViewer() {
        setShowImageViewer(false);
        setShowSideBar(true);
        setShowTopBar(true);

        ReactGA.event({
            category: "Image viewer",
            action: "closed",
            label: "xx",
            value: 1
        });
    }

    return (
        <ElementsContext.Provider
            value={{
                elements,
                setElements,
                focusedImage,
                setFocusedImage,
                showGallery,
                setShowGallery,
                showImageViewer,
                setShowImageViewer,
                inspection,
                setInspection,
                focusedInspectionElement,
                setFocusedInspectionElement,
                openGallery,
                openImageViewer,
                closeImageViewer
            }}
        >
            {children}
        </ElementsContext.Provider>
    );
}
